import { Header } from '../components/Header/Header';
import { CardInfo } from '../components/CardInfo/CardInfo';
import { CardHeader } from '../components/CardHeader/CardHeader';
import { CardBody } from '../components/CardBody/CardBody';
import {Col, Row, Container, Spinner, Button} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';
import { useEffect, useState } from 'react';
import { api } from '../services/Api';
import { useAlert } from '../contexts/AlertContext';
import {Invoice} from "../components/Invoice/Invoice";
import {useAuth} from "../contexts/AuthenticationContext";

type InvoicesType = {
	baixado: number;
	boleto: number;
	cobranca_entrada_confirmada: number;
	id_cobranca_registro_lancamento: number;
	data_vencimento: string;
	id: number;
	id_status: number;
	numero_contrato: string;
	numero_documento: string;
	plano: string;
	status: string;
	valor_documento: number;
	valor_juros: number;
	valor_multa: number;
	valor_total: number;
}

export function Invoices() {
	const history = useHistory();

	const { session } = useAuth();

	const { handleSetAlert } = useAlert();

	const [openInvoice, setOpenInvoice] = useState<InvoicesType[] | null>(null);
	const [paidInvoices, setPaidInvoices] = useState<InvoicesType[] | null>(null);
	const [futureInvoices, setFutureInvoices] = useState<InvoicesType[] | null>(null);
	const [loadingInvoices, setLoadingInvoices] = useState(false);

	let date = new Date();
	let actualDate = '';
	actualDate = (date.getFullYear()+""+("0"+(date.getMonth()+1)).substr(-2));

	useEffect(() => {
		if(session){
			setLoadingInvoices(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/pessoas/clientes/contratos/'+session.id_contract+'/faturas', { headers })
				.then((response) => {

					let paid = [] as InvoicesType[];
					let future = [] as InvoicesType[];
					let open = [] as InvoicesType[];

					response.data.forEach((element: InvoicesType)  => {
						if (element.status === 'aberto') {
							let invoiceDueDate = element.data_vencimento.split('-');
							if(element.boleto===1 && element.cobranca_entrada_confirmada===1) {
								open.push(element);
							}else if(element.boleto===0 && actualDate>=(invoiceDueDate[0]+invoiceDueDate[1]) ) {
								open.push(element);
							}else{
								future.push(element);
							}
						} else if (element.status === 'vencido') {
							open.push(element);
						} else if (element.status === 'pago') {
							paid.push(element);
						}
					});
					setOpenInvoice(open);
					setPaidInvoices(paid);
					setFutureInvoices(future);
					setLoadingInvoices(false);
				}).catch(error => {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: error.response.data.message,
					timeout: 5000
				});
				history.goBack();
				setLoadingInvoices(false);
			});
		}
	}, [session, actualDate, history, handleSetAlert])

	return(
		<>
			<Header/>
			<Container>
				<Row className="m-2 mt-3 mb-3">
					<Col md={6} className="d-flex p-0">
						<h3 className="title-page d-flex">
							<Button variant={""} className="d-flex shadow-none p-0" onClick={() => {history.goBack()}}>
								<span className="material-icons title-icon">keyboard_arrow_left</span>
							</Button>
							<span className="material-icons title-icon">local_atm</span>
							Faturas
						</h3>
					</Col>
				</Row>
				<Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-default">
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">folder_open</span>
										Em Aberto
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingInvoices && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!loadingInvoices && openInvoice?.length === 0 && <div className="justify-content-center align-items-center d-flex">
											<p className="text-center">Nenhuma fatura aberta encontrada</p>
										</div>
										}
										{!loadingInvoices && openInvoice?.length !== 0 && openInvoice?.map((invoice, key) => (
											<div key={key}>
												<Invoice invoice={invoice}/>
											</div>
										))}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-success">
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">done</span>
										Pagas
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingInvoices && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!loadingInvoices && paidInvoices?.length === 0 && <div className="justify-content-center align-items-center d-flex">
											<p className="text-center">Nenhuma fatura paga encontrada</p>
										</div>
										}
										{!loadingInvoices && paidInvoices?.length !== 0 && paidInvoices?.map((invoice, key) => (
											<div key={key}>
												<Invoice invoice={invoice}/>
											</div>
										))}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-info">
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">update</span>
										Futuras
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingInvoices && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!loadingInvoices && futureInvoices?.length === 0 && <div className="justify-content-center align-items-center d-flex">
											<p className="text-center">Nenhuma fatura futura encontrada</p>
										</div>
										}
										{!loadingInvoices && futureInvoices?.length !== 0 && futureInvoices?.map((invoice, key) => (
											<div key={key}>
												<Invoice invoice={invoice}/>
											</div>
										))}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
				</Row>
			</Container>
		</>
	);
}
